(function () {
  var RUN_FLAG = "data-atc-injected";
  var DEBOUNCE_TIMER = null;

  function debounceInject() {
    clearTimeout(DEBOUNCE_TIMER);
    DEBOUNCE_TIMER = setTimeout(injectButtons, 250);
  }

  function getProductHandleFromUrl(url) {
    if (!url) return null;
    try {
      var u = new URL(url, window.location.origin);
      var parts = u.pathname.split("/products/");
      if (parts.length < 2) return null;
      var handle = parts[1].split("/")[0].split("?")[0];
      return handle || null;
    } catch (e) {
      return null;
    }
  }

  async function getFirstVariantId(handle) {
    var res = await fetch("/products/" + handle + ".js", { credentials: "same-origin" });
    if (!res.ok) return null;
    var data = await res.json();
    if (!data || !data.variants || !data.variants.length) return null;
    var v = data.variants.find(function (x) { return x.available; }) || data.variants[0];
    return v ? v.id : null;
  }

  async function addToCart(variantId) {
    var res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw new Error("Add to cart failed");
    return res.json();
  }

  function findProductCards() {
    // Narrower + safer selectors (avoid nested duplicates)
    var selectors = [
      ".xo-product-card",
      ".product-card",
      ".product-item",
      "[data-product-card]"
    ];
    var nodes = document.querySelectorAll(selectors.join(","));
    return Array.prototype.slice.call(nodes);
  }

  function findProductLink(card) {
    return card.querySelector("a[href*='/products/']");
  }

  function getStableKey(card, handle) {
    // Use handle as unique key, fallback to card index later
    return handle ? "handle:" + handle : null;
  }

  function ensureSingleButton(card) {
    // Remove any previously injected duplicates inside this card
    var buttons = card.querySelectorAll(".inject-atc-btn");
    if (buttons.length > 1) {
      for (var i = 1; i < buttons.length; i++) buttons[i].remove();
    }
  }

  function findInsertPoint(card) {
    // Try common info container first, else use card itself
    return (
      card.querySelector(".xo-product-card__info") ||
      card.querySelector(".product-card__info") ||
      card.querySelector(".product-item__info") ||
      card.querySelector(".product-card__content") ||
      card.querySelector(".product-item__content") ||
      card
    );
  }

  function createButton(handle) {
  var btn = document.createElement("button");
  btn.type = "button";
  btn.className = "inject-atc-btn";
  btn.textContent = "View options";
  btn.setAttribute("data-handle", handle);

  btn.addEventListener("click", function (e) {
    var h = e.currentTarget.getAttribute("data-handle");
    if (!h) return;
    window.location.href = "/products/" + h;
  });

  return btn;
}


  function injectButtons() {
    var cards = findProductCards();
    if (!cards.length) return;

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];

      var link = findProductLink(card);
      if (!link) continue;

      var handle = getProductHandleFromUrl(link.getAttribute("href"));
      if (!handle) continue;

      // Hard guard: mark card as injected once (prevents re-append)
      if (card.getAttribute(RUN_FLAG) === "true") {
        // still cleanup if theme duplicated inside
        ensureSingleButton(card);
        continue;
      }

      // If button already exists, just mark and move on
      if (card.querySelector(".inject-atc-btn")) {
        card.setAttribute(RUN_FLAG, "true");
        ensureSingleButton(card);
        continue;
      }

      var insertPoint = findInsertPoint(card);

      var btn = createButton(handle);

      insertPoint.appendChild(btn);

      // Mark injected
      card.setAttribute(RUN_FLAG, "true");
    }
  }

  function init() {
    injectButtons();

    // Observe but debounce (avoid rapid injections)
    var mo = new MutationObserver(function () {
      debounceInject();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
